<script>
export default {
  name: 'SupportHead',
}
</script>

<template>
  <div class="support-head">
    <div class="support-head__title tamara-english-medium-3">
      <svg-icon name="support" width="20px" height="20px" />
      {{ $t('sidebar_support_widget_title') }}
    </div>
    <div class="support-head__description tamara-english-regular-3">
      {{ $t('sidebar_support_widget_description') }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.support-head {
  &__title {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    color: var(--tamara-color-content-high);
  }

  &__description {
    color: var(--tamara-color-content-mid);
  }
}
</style>
